import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { api, formatError } from "@/lib/api";

export default function ResetPage() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      setDone(true);
    } catch (err) {
      setError(formatError(err));
    }
  };

  return (
    <AuthShell kicker="Recupero" title="Nuova password.">
      {done ? (
        <p data-testid="reset-success">Password aggiornata. Ora puoi accedere.</p>
      ) : (
        <form onSubmit={submit} className="space-y-8">
          <label className="block">
            <span className="rf-mono text-[11px] uppercase tracking-widest text-[var(--rf-grey)]">Nuova password</span>
            <input type="password" minLength={6} required className="rf-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
          </label>
          {error && <p className="text-sm rf-red" data-testid="reset-error">{error}</p>}
          <button className="rf-btn" data-testid="reset-submit-button">Salva password</button>
        </form>
      )}
      <Link to="/login" className="inline-block mt-12 text-sm underline underline-offset-4" data-testid="reset-back-link">← Vai all'accesso</Link>
    </AuthShell>
  );
}
